import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'beneficiary',
    standalone: false
})
export class BeneficiaryPipe implements PipeTransform {

    static format(firstName: string, lastName: string, matricule: string): string {
        return [lastName, firstName].filter(e => !!e).join(' ') + (matricule ? ' (' + matricule + ')' : '');
    }

    transform(value: any, firstName: string = 'PrenomBenef', lastName: string = 'NomBenef', matricule: string = 'Matricule'): string {
        return BeneficiaryPipe.format(value?.[firstName], value?.[lastName], value?.[matricule]);
    }
}
